'use strict';

import { sortByUsage } from '@/utils';

const mostUsedDispositionCodes = state => state.mostUsed.sort(sortByUsage);

export default {
  mostUsedDispositionCodes
};
